import { actionsForm } from "../Components/Prospects/NewProspect/data";

export const actionTypesByStatus = {
  Prospect: ["Nuturing", "Call", "Email", "Prospecting Visit"],
  Interested: ["Call", "Email", "In-store Appointment", "Video Appointment"],
  "Pending signature": [
    "Sending the Area",
    "Sending the Contract",
    "Transition to Store Partner",
    "Call",
    "Email",
    "In-store Appointment",
    "Video Appointment",
  ],
  "In discussion": [
    "Call",
    "Email",
    "In-store Appointment",
    "Video Appointment",
  ],
};
// Project-only statuses (Espace clients pipeline): the generic actions.
["Sale", "Nursery", "Lost", "Abandoned"].forEach((status) => {
  actionTypesByStatus[status] = actionTypesByStatus["In discussion"];
});

export const getInterlocutorFullname = (interlocutor) => {
  const { firstName = "", lastName = "" } = interlocutor?.attributes ?? {};
  return `${firstName} ${lastName}`.trim();
};

export const getProspectActionTypeOptions = (status, action, t) => {
  const types = actionTypesByStatus[status] ?? [];
  const filteredTypes =
    action === "REMINDER" && status === "Prospect"
      ? types.filter((type) => type !== "Nuturing")
      : types;

  return filteredTypes.map((type) => ({ name: t(type), code: type }));
};

export const getInterlocutorOptions = (interlocutors, t) =>
  (interlocutors ?? []).map((interlocutor) => {
    const fullName = getInterlocutorFullname(interlocutor);
    return {
      name: t(fullName),
      code: interlocutor.id,
    };
  });

export const getActionFormTitle = (action, UPDATE, t) =>
  t(
    action === "ACTION"
      ? UPDATE
        ? "Edit Action"
        : "Add Action"
      : UPDATE
      ? "Edit Reminder"
      : "Add Reminder"
  );

export const initialActionFormData = (data, t) => {
  if (!data) return {};

  const { date, interlocutor, ...rest } = data;
  return {
    ...rest,
    date: new Date(date),
    type: {
      name: t(`${data.type}`),
      code: data.type,
    },
    interlocutor: {
      name: `${interlocutor?.data?.attributes?.firstName ?? ""} ${
        interlocutor?.data?.attributes?.lastName ?? ""
      }`.trim(),
      code: interlocutor?.data?.id,
    },
  };
};

export const getValidTypeForActionStatus = (status, type, t) => {
  if (!status) return undefined;
  const types = actionTypesByStatus[status] ?? [];
  const matchedType = types?.find(
    (item) => item?.toLowerCase() === (type ?? "").toLowerCase()
  );
  return matchedType ? { name: t(matchedType), code: matchedType } : undefined;
};

export const isActionFormValid = (action, formData) => {
  if (action === "REMINDER" && !formData.date) return false;
  return actionsForm.every((field) => {
    if (!field.required) return true;
    const value = formData[field.name];
    return value !== undefined && value !== null && value !== "";
  });
};
